export const mode = [
    {
        title: 'motions.title',
        mediumImage: 'assets/images/get-started/start-the-kinomap-experience/1-scenic-video/Photo-1.jpg',
        smallImage1: 'assets/images/modeKinomap/svg/motionVideo-small.svg',
        smallImage2: 'assets/images/get-started/start-the-kinomap-experience/1-scenic-video/Photo-3.jpg',
        span: 'motions.secondary2'

    },
    {
        title: 'coaching.title',
        mediumImage: 'assets/images/get-started/start-the-kinomap-experience/2-coaching-video/Photo-1.jpg',
        smallImage1: 'assets/images/modeKinomap/svg/coachingVideo-small.svg',
        smallImage2: 'assets/images/modeKinomap/svg/coachingVideo-small2.svg',
        span: 'coaching.secondary2'

    },
    {
        title: 'multiplayer.title',
        mediumImage: 'assets/images/get-started/start-the-kinomap-experience/3-multiplayer-sessions/Photo-1.jpg',
        smallImage1: 'assets/images/get-started/start-the-kinomap-experience/3-multiplayer-sessions/Photo-2.jpg',
        smallImage2: 'assets/images/get-started/start-the-kinomap-experience/3-multiplayer-sessions/Photo-3.jpg',
        span: 'multiplayer.secondary2'

    },
    {
        title: 'freeride.title',
        mediumImage: 'assets/images/get-started/start-the-kinomap-experience/4-free-ride/Photo-1.jpg',
        smallImage1: 'assets/images/get-started/start-the-kinomap-experience/4-free-ride/Photo-3.jpg',
        smallImage2: 'assets/images/get-started/start-the-kinomap-experience/4-free-ride/Photo-2.jpg',
        span: 'freeride.secondary2'

    },
    {
        title: 'structuredWorkout.title',
        mediumImage: 'assets/images/get-started/start-the-kinomap-experience/5-structured-workout/Photo-1.jpg',
        smallImage1: 'assets/images/get-started/start-the-kinomap-experience/5-structured-workout/Photo-2.jpg',
        smallImage2: 'assets/images/get-started/start-the-kinomap-experience/5-structured-workout/Photo-3.jpg',
        span: 'structuredWorkout.secondary'

    },
    {
      title: 'homepage.carousel.map.title',
      mediumImage: 'assets/images/get-started/start-the-kinomap-experience/6-gps-tracks/Photo-1.jpg',
      smallImage1: 'assets/images/get-started/start-the-kinomap-experience/6-gps-tracks/Photo-2.jpg',
      smallImage2: 'assets/images/get-started/start-the-kinomap-experience/6-gps-tracks/Photo-3.jpg',
      span: 'homepage.carousel.map.text'

  },

  ];
